import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, TableContainer, Table, TableBody, TableRow, TableCell } from "@material-ui/core";
import InformationDialog from '../../Common/InformationDialog';
import { notArrayOrEmpty } from '../../../utils/helpers';
import guid from "../../../utils/guid";
import t from "../../../languages/pl";

const useStyles = () => ({
    cell: {
        padding: 5,
        textAlign: "center"
    }
});

const NotificationDialog = props => {
    const { classes, data, onClose } = props;
    const [incompleteRecords, setIncompleteRecords] = useState([]);
    const [duplicatedNameOrRFID, setDuplicatedNameOrRFID] = useState([]);
    const [incorrectEmails, setIncorrectEmails] = useState([]);
    const [incorrectPhoneNos, setIncorrectPhoneNos] = useState([]);

    useEffect(() => {
        if (data !== null) {
            setIncompleteRecords(data.incompleteRecords);
            setDuplicatedNameOrRFID(data.duplicatedNameOrRFID);
            setIncorrectEmails(data.withoutValidEmail);
            setIncorrectPhoneNos(data.withoutValidPhone);
        }
    }, [data]);

    const printNotValidData = (records, secondKey = 'kierowca_rfid') => {
        if (notArrayOrEmpty(records))
            return;
        return records.map(row => {
            return (
                <TableRow key={guid()}>
                    <TableCell className={classes.cell}>
                        {row.kierowca_nazwa}
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {row[secondKey]}
                    </TableCell>
                </TableRow>
            );
        });
    };

    return (
        <InformationDialog
            open={data !== null}
            onClose={onClose}
            size="sm"
            title={t.driversDoNotMeetTheImportRequirements}
        >
            <TableContainer>
                <Table>
                    <TableBody>
                        {
                            duplicatedNameOrRFID.length > 0
                            &&
                            <>
                                <TableRow selected>
                                    <TableCell colSpan={2}>
                                        Kierowcy, dla których istnieje duplikat Nazwy lub RFID
                                    </TableCell>
                                </TableRow>
                                {printNotValidData(duplicatedNameOrRFID)}
                            </>
                        }
                        {
                            incompleteRecords.length > 0
                            &&
                            <>
                                <TableRow selected>
                                    <TableCell colSpan={2}>
                                        Kierowcy, dla których nie wpisano poprawnie wymaganych pól
                                    </TableCell>
                                </TableRow>
                                {printNotValidData(incompleteRecords)}
                            </>
                        }
                        {
                            incorrectEmails.length > 0
                            &&
                            <>
                                <TableRow selected>
                                    <TableCell colSpan={2}>
                                        Kierowcy, dla których nie wpisano poprawnego adresu email
                                    </TableCell>
                                </TableRow>
                                {printNotValidData(incorrectEmails, "kierowca_email")}
                            </>
                        }
                        {
                            incorrectPhoneNos.length > 0
                            &&
                            <>
                                <TableRow selected>
                                    <TableCell colSpan={2}>
                                        Kierowcy, dla których nie wpisano poprawnego numeru telefonu
                                    </TableCell>
                                </TableRow>
                                {printNotValidData(incorrectPhoneNos, "kierowca_email")}
                            </>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

        </InformationDialog>
    );
};

NotificationDialog.propTypes = {
    data: PropTypes.object,
    classes: PropTypes.object,
    onClose: PropTypes.func
};

export default withStyles(useStyles)(NotificationDialog);
